var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstituteStudents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.012,
    height: 32,
    viewBox: "0 0 29.012 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#e);}.f{fill:url(#f);}.g{fill:url(#g);}.h{fill:url(#h);}.i{fill:url(#i);}.j{fill:url(#j);}.k{fill:url(#k);}.l{fill:url(#l);}.m{fill:url(#m);}.n{fill:url(#n);}.o{fill:url(#o);}.p{fill:url(#q);}.q{fill:url(#r);}.r{fill:url(#s);}.s{fill:url(#t);}.t{fill:url(#v);}.u{fill:url(#y);}.v{fill:url(#ac);}.w{fill:url(#ad);}.x{fill:url(#aj);}.y{fill:url(#ap);}.z{fill:url(#aq);}.aa{fill:url(#ar);}.ab{fill:url(#as);}.ac{fill:url(#at);}.ad{fill:url(#au);}.ae{fill:url(#av);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.29,
    y1: 0.06,
    x2: 0.702,
    y2: 0.923,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555a66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.206,
    y1: 0.392,
    x2: 1.798,
    y2: 0.942,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.596,
    y1: 0.554,
    x2: 0.171,
    y2: 0.496,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.408,
    y1: 0.292,
    x2: 0.207,
    y2: -0.178,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.14,
    y1: 1.561,
    x2: 0.49,
    y2: 0.19,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.394,
    y1: 0.43,
    x2: 1.318,
    y2: 1.219,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.451,
    y1: 0.427,
    x2: 0.124,
    y2: -0.273,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.019,
    y1: 0.5,
    x2: 0.986,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -1.792,
    y1: 0.524,
    x2: 1.533,
    y2: 0.485,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9edf5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 1.582,
    y1: 1.082,
    x2: 0.074,
    y2: -0.426,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#c8b7e0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#a595c8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8f81b8",
    stopOpacity: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.313,
    y1: 0.313,
    x2: 0.961,
    y2: 0.961,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.696,
    y1: 0.696,
    x2: 0.154,
    y2: 0.154,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9edf5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.491,
    y1: 0.674,
    x2: 1.216,
    y2: -0.675,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.147,
    y1: 0.5,
    x2: 1.234,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdaaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcb37e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -43.436,
    x2: -42.35,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0.681,
    y1: 0.676,
    x2: 0.445,
    y2: -0.104,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0.46,
    y1: 0.076,
    x2: 0.498,
    y2: 0.574,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.5,
    y1: 0.24,
    x2: 0.5,
    y2: 1.168,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 0.532,
    y1: 1.031,
    x2: 0.489,
    y2: -0.093,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -48.313,
    x2: -47.226,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 0.46,
    y1: 0.076,
    x2: 0.498,
    y2: 0.574,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: -53.19,
    x2: -52.104,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 0.147,
    x2: 1.234,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: -58.069,
    x2: -56.983,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 0.366,
    y1: 0.305,
    x2: 0.635,
    y2: 1.568,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 0.533,
    y1: 1.632,
    x2: 0.363,
    y2: -1.594,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 0.539,
    y1: 1.101,
    x2: 0.42,
    y2: -0.569,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 0.292,
    y1: 0.544,
    x2: -0.197,
    y2: -0.426,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 0.493,
    y1: 0.256,
    x2: 0.507,
    y2: 1.086,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 0.5,
    y1: 0.582,
    x2: 0.527,
    y2: 1.766,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 0.5,
    y1: 0.255,
    x2: 0.5,
    y2: 1.499,
    xlinkHref: "#q"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.813)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M100.037,215.214h19.446V230.7H100.037Z",
    transform: "translate(-71.441 -201.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M294.359,27.978h-3.023a.286.286,0,0,1-.286-.286V23.883h3.309a.135.135,0,0,1,.127.18l-.549,1.547a.96.96,0,0,0,0,.642l.549,1.547A.135.135,0,0,1,294.359,27.978Z",
    transform: "translate(-250.469 -22.384)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M293.937,26.253a.959.959,0,0,1-.013-.6l-1.766-1.766h-1.107v3.809a.286.286,0,0,0,.286.286h3.023a.135.135,0,0,0,.127-.18Z",
    transform: "translate(-250.47 -22.385)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M294.381,35.042l-.022,0h-3.023a.286.286,0,0,1-.286-.286V31.422h3.309l.022,0-.445,1.252a.961.961,0,0,0-.026.558q.011.043.026.085l.549,1.547A.135.135,0,0,1,294.381,35.042Z",
    transform: "translate(-250.469 -29.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M291.051,72.015V72.8a.286.286,0,0,0,.286.286h.44a.118.118,0,0,1-.083-.2l.37-.37a.285.285,0,0,0,.1-.213v-.292Z",
    transform: "translate(-250.47 -67.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M256.134,20.051h-3.213v-4.1h3.213a.286.286,0,0,1,.286.286v3.523A.286.286,0,0,1,256.134,20.051Z",
    transform: "translate(-214.733 -14.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M256.134,23.148h-3.213v3.644h3.213a.286.286,0,0,0,.286-.286V23.434A.286.286,0,0,0,256.134,23.148Z",
    transform: "translate(-214.733 -21.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M250.426,23.522a.331.331,0,0,1-.331-.331V15.956h.662v7.235A.331.331,0,0,1,250.426,23.522Z",
    transform: "translate(-212.084 -14.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M253.657,23.5a.331.331,0,0,0,.226-.314V15.956h-.453v7.235A.331.331,0,0,0,253.657,23.5Z",
    transform: "translate(-215.211 -14.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M250.756,16.618v-.662h-.662Z",
    transform: "translate(-212.083 -14.955)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 0.556,
    cy: 0.556,
    r: 0.556,
    transform: "translate(37.786 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 0.464,
    cy: 0.464,
    r: 0.464,
    transform: "translate(37.878 0.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M248.186.935a.557.557,0,0,1-.747.747.556.556,0,1,0,.747-.747Z",
    transform: "translate(-209.595 -0.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M64.375,242.313H68.85v12.5H64.375Z",
    transform: "translate(-38.017 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M78.857,254.809h2.658v-12.5H78.857Z",
    transform: "translate(-51.59 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M92.776,242.313h.911v12.5h-.911Z",
    transform: "translate(-64.636 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M64.375,243.459l4.475,6.227v-7.374H64.375Z",
    transform: "translate(-38.017 -227.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M64.906,422.948H60.4a.248.248,0,0,1-.248-.248v-1.462a.757.757,0,0,1,.757-.757H64.4a.757.757,0,0,1,.757.757V422.7A.248.248,0,0,1,64.906,422.948Z",
    transform: "translate(-34.056 -394.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M60.4,223.98h4.509a.248.248,0,0,1,.248.248v1.462a.757.757,0,0,1-.757.757H60.906a.757.757,0,0,1-.757-.757v-1.462A.248.248,0,0,1,60.4,223.98Z",
    transform: "translate(-34.056 -209.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M64.944,223.98H60.36c-.116,0-.211.131-.211.293v.419l1.261,1.755h3.1c.354,0,.641-.4.641-.893v-1.282C65.154,224.111,65.06,223.98,64.944,223.98Z",
    transform: "translate(-34.056 -209.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M167.684,242.313h4.475v12.5h-4.475Z",
    transform: "translate(-134.844 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M182.165,254.809h2.658v-12.5h-2.658Z",
    transform: "translate(-148.416 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M196.085,242.313H197v12.5h-.911Z",
    transform: "translate(-161.463 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M167.684,243.459l4.475,6.227v-7.374h-4.475Z",
    transform: "translate(-134.844 -227.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M168.215,422.948h-4.509a.248.248,0,0,1-.248-.248v-1.462a.757.757,0,0,1,.757-.757h3.492a.757.757,0,0,1,.757.757V422.7A.248.248,0,0,1,168.215,422.948Z",
    transform: "translate(-130.883 -394.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M163.707,223.98h4.509a.248.248,0,0,1,.248.248v1.462a.757.757,0,0,1-.757.757h-3.492a.757.757,0,0,1-.757-.757v-1.462A.248.248,0,0,1,163.707,223.98Z",
    transform: "translate(-130.884 -209.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M168.253,223.98h-4.584c-.116,0-.211.131-.211.293v.419l1.261,1.755h3.1c.354,0,.641-.4.641-.893v-1.282C168.463,224.111,168.369,223.98,168.253,223.98Z",
    transform: "translate(-130.883 -209.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M270.993,242.313h4.475v12.5h-4.475Z",
    transform: "translate(-231.671 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M285.474,254.809h2.658v-12.5h-2.658Z",
    transform: "translate(-245.243 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M299.394,242.313h.911v12.5h-.911Z",
    transform: "translate(-258.29 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M270.993,243.459l4.475,6.227v-7.374h-4.475Z",
    transform: "translate(-231.671 -227.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M271.523,422.948h-4.509a.248.248,0,0,1-.248-.248v-1.462a.757.757,0,0,1,.757-.757h3.492a.757.757,0,0,1,.757.757V422.7A.248.248,0,0,1,271.523,422.948Z",
    transform: "translate(-227.709 -394.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M267.015,223.98h4.509a.248.248,0,0,1,.248.248v1.462a.757.757,0,0,1-.757.757h-3.492a.757.757,0,0,1-.757-.757v-1.462A.248.248,0,0,1,267.015,223.98Z",
    transform: "translate(-227.71 -209.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M271.562,223.98h-4.584c-.116,0-.211.131-.211.293v.419l1.261,1.755h3.1c.354,0,.641-.4.641-.893v-1.282C271.772,224.111,271.678,223.98,271.562,223.98Z",
    transform: "translate(-227.71 -209.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M374.3,242.313h4.475v12.5H374.3Z",
    transform: "translate(-328.497 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M388.783,254.809h2.658v-12.5h-2.658Z",
    transform: "translate(-342.07 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M402.7,242.313h.911v12.5H402.7Z",
    transform: "translate(-355.116 -227.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M374.3,243.459l4.475,6.227v-7.374H374.3Z",
    transform: "translate(-328.497 -227.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M374.832,422.948h-4.509a.248.248,0,0,1-.248-.248v-1.462a.757.757,0,0,1,.757-.757h3.492a.757.757,0,0,1,.757.757V422.7A.248.248,0,0,1,374.832,422.948Z",
    transform: "translate(-324.536 -394.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M370.324,223.98h4.509a.248.248,0,0,1,.248.248v1.462a.757.757,0,0,1-.757.757h-3.492a.757.757,0,0,1-.757-.757v-1.462A.248.248,0,0,1,370.324,223.98Z",
    transform: "translate(-324.537 -209.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M374.871,223.98h-4.584c-.116,0-.211.131-.211.293v.419l1.261,1.755h3.1c.354,0,.641-.4.641-.893v-1.282C375.081,224.111,374.987,223.98,374.871,223.98Z",
    transform: "translate(-324.537 -209.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M35.941,104.017,24.1,110.908a.566.566,0,0,0,.284,1.055H52.258a.566.566,0,0,0,.284-1.055L40.7,104.017A4.729,4.729,0,0,0,35.941,104.017Z",
    transform: "translate(0 -96.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M57.9,125.761l10.486-6.1a3.739,3.739,0,0,1,3.76,0l10.486,6.1Z",
    transform: "translate(-31.953 -111.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M69.726,120.275a3.734,3.734,0,0,1,2.82-.386l-.395-.23a3.739,3.739,0,0,0-3.76,0L57.9,125.76H60.3Z",
    transform: "translate(-31.953 -111.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M269.224,110.908l-11.846-6.892a4.726,4.726,0,0,0-2.378-.641v8.588h13.939A.566.566,0,0,0,269.224,110.908Z",
    transform: "translate(-216.681 -96.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M43.74,444.052H70.251v-1.684a.9.9,0,0,0-.9-.9H44.639a.9.9,0,0,0-.9.9v1.684Z",
    transform: "translate(-18.677 -413.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M24.206,471.415H52.432a.393.393,0,0,0,.393-.393v-1.291a.9.9,0,0,0-.9-.9H24.712a.9.9,0,0,0-.9.9v1.291A.393.393,0,0,0,24.206,471.415Z",
    transform: "translate(0 -439.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M23.813,489.416v.913a.394.394,0,0,0,.408.378h28.2a.394.394,0,0,0,.408-.378v-.913Z",
    transform: "translate(0 -458.708)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstituteStudents);
export default __webpack_public_path__ + "static/media/institute-students.9004d16057b0d44740ff70985391011a.svg";
export { ForwardRef as ReactComponent };